import { Component, Input } from '@angular/core';

@Component({
  selector: 'sidenav',
  templateUrl: './sidenav.component.html'
})
export class SidenavComponent {

  @Input() menus: object;

}
